import React, { useEffect, useState } from 'react'
import TransferenciasGlobaisApi from '../../services/robinhood/TransferenciasGlobaisApi'

export default function TransferenciasGlobaisTotalCount(props) {

    const backgroundColor = props.backgroundColor ? props.backgroundColor : null;

    return (
        <>
            <div className="col-lg-3 col-sm-6 col-md-6 col-xs-12">
                <div className={`card ${backgroundColor}`}>
                    <div className={`body ${backgroundColor && 'text-white'}`}>
                        <h5> <i className={''}></i> R$ {Intl.NumberFormat('pt-BR').format(Object.values(props.dados).reduce((total, value) => total + parseFloat(value), 0))}</h5>
                        <p className={`${!backgroundColor && 'text-muted'}`}> <i className='zmdi zmdi-calendar' style={{ fontSize: '14px', }}></i> {props.ano}</p>
                        <div className="progress m-t-20">
                            <div className="progress-bar l-green" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style={{ width: '100%' }}></div>
                        </div>
                        <span className="text-small">TOTAL LÍQUIDO NO ANO</span> </div>
                </div>
            </div >

            {/* <div class="col-lg-3 col-sm-6 col-md-6 col-xs-12">
                        <div class="card">
                            <div class="body">
                                <h5><i className='zmdi zmdi-money'></i>  (EM DESENVOLVIMENTO)</h5>
                                <p class="text-muted">EM REAIS</p>
                                <div className="progress m-t-20">
                                    <div className="progress-bar l-blush" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style={{ width: '20%' }}></div>
                                </div>
                                <span class="text-small">TOTAL BRUTO NO ANO</span> </div>
                        </div>
                    </div> */}

        </>
    )
}

